<div class="wrapper" style="width:100%">
  <header class="header">
    <lib-header [app]="'builder'" [menuItems]="menuItems"></lib-header>
  </header>
  <lib-loader></lib-loader>
  <lib-unit-settings-dialogue></lib-unit-settings-dialogue>
  <section class="content">
    <div *ngIf="!loggedIn" style="width:50%;min-width:400px;margin-left:auto;margin-right:auto;">
      <login (loginStateChange)="setLoggedIn($event)"></login>
    </div>
    <status-bar *ngIf="loggedIn && cacheLoading" style="width:300px;margin-left:auto;margin-right:auto;margin-top:100px" [status]="{state:'loading',message:'Loading Reference Data'}"></status-bar>
    
    <div *ngIf="loggedIn && !cacheLoading" class="app-row">
      <div class="app-column-one">        
        <div>
          <app-pumpset-selection-list *ngIf="cacheLoadedAndNotSharing && showPumpList" context="Pumpset"></app-pumpset-selection-list>
        </div>
        <app-pumpset-builder-form [pumpsetId]="sharedPumpsetId"></app-pumpset-builder-form>
      </div>
      <div class="app-column-two">
        <app-diagram></app-diagram>
      </div>
    </div>
  </section>
  <footer class="footer">
    <lib-footer></lib-footer>
  </footer>
</div>
<app-list-dialogue></app-list-dialogue>
<app-share-dialogue></app-share-dialogue>

